import { BmiRiskLevel } from '@models/assessment';

import { Gender } from 'generated/types';

import type { ReferenceRange } from './types';

const referenceRange: ReferenceRange<BmiRiskLevel> = new Map([
  [
    Gender.unknown,
    new Map([
      [BmiRiskLevel.High1, [{ upper: 19 }]],
      [
        BmiRiskLevel.Low,
        [
          {
            lower: 19,
            upper: 25,
          },
        ],
      ],
      [
        BmiRiskLevel.Medium,
        [
          {
            lower: 25,
            upper: 30,
          },
        ],
      ],
      [
        BmiRiskLevel.High2,
        [
          {
            lower: 30,
          },
        ],
      ],
    ]),
  ],
]);

export default referenceRange;
